import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';

export default {
  methods: {
    mixAvanceFinancieroALaFecha(fecha) {
      const noDatos = { fechaTermino: null, avance: 0 };
      if (!this.contratoEstimaciones) return noDatos;
      const aLaFecha = new Date(`${fecha} 00:00:0`);
      return this.mixGetAvanceFinanciero
        .filter(({ fechaTermino }) => aLaFecha >= new Date(`${fechaTermino} 00:00:0`))
        .pop() || noDatos;
    },
  },
  apollo: {
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones;
    },
    mixGetAvanceFinanciero() {
      if (!this.contratoEstimaciones) return [];

      let total = 0;

      return this.getEstimaciones
        .sort((a, b) => new Date(`${a.fechaAl} 00:00:0`) - new Date(`${b.fechaAl} 00:00:0`))
        .map((item) => {
          total += item.importeEstimado;
          return {
            fechaTermino: item.fechaAl,
            avance: this.$numberRound((total / this.importeDelContrato) * 100),
          };
        });
    },
  },
};
